import { createMeetingWatcherSaga } from './createMeetingBlock.saga'
import { destroyMeetingBlockWatcherSaga } from './destroyMeetingBlock.saga'
import { editMeetingBlockWatcherSaga } from './editMeetingBlock.saga'

export const meetingSagas = [
  createMeetingWatcherSaga(),
  destroyMeetingBlockWatcherSaga(),
  editMeetingBlockWatcherSaga(),
]

export default meetingSagas
